import { axios } from "../../helper/axios";
import { NavigationConstant } from "./NavigationConstant";

const NavigationApiData = {};

NavigationApiData.getNavigationApiData = ({
  from_date,
  to_date,
  search_term,
  page = 1,
  limit,
  sorting
}) => {
  let qeuryParam = [];

  if (search_term) {
    qeuryParam.push(`search=${search_term}`);
  }
  if (from_date && to_date) {
    qeuryParam.push(`startDate=${from_date}&endDate=${to_date}`);
  }
  if (page) {
    qeuryParam.push(`page=${page}`);
  }
  if (limit) {
    qeuryParam.push(`pageSize=${limit}`);
  }
  if (sorting) {
    qeuryParam.push(`checkIn=${sorting}`);
  }

  // Join all parameters with '&'
  const queryString = qeuryParam.length ? `?${qeuryParam.join('&')}` : '';

  return axios.get(`${NavigationConstant.NAVIGATION_API}${queryString}`);
};

NavigationApiData.exportNavigationApiData = ({
  limit
}) => {
  let qeuryParam = [];

  if (limit) {
    qeuryParam.push(`pageSize=${limit}`);
  }

  const queryString = qeuryParam.length ? `?${qeuryParam.join('&')}` : '';

  return axios.get(`${NavigationConstant.NAVIGATION_API}${queryString}`);
};

export { NavigationApiData };
